import React, { useState, useContext, useEffect } from "react";
import axios from "../../../../axios/index";

import { UserContext } from "../../../Context/UserContextProvider";
import Checkbox from "@mui/material/Checkbox";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import { settingContactInfoFormValidate } from "./settingContactInfoFormValidate";

// Styles
import styles from "./../Settings.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";
import seoStyles from "../../Blogs/AddBlog/AddBlog.module.css";

const SettingContactInfoForm = props => {
  const { userToken } = useContext(UserContext);
  const [btnLoader, setBtnLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [formContactValue, setFormContactValue] = useState({
    addressCompany: "",
    phone: "",
    mobile: "",
    instagramUrl: "",
    telegramUrl: "",
    whatsappUrl: "",
    email: "",
    footerText: "",
    seoTitle: "",
    seoDescription: "",
    seoKeywords: "",
    seoIndexPage: false,
    seoCanonical: "",
    seoSchema: "",
  });

  useEffect(() => {
    const dataHandler = async () => {
      const getSiteSettings = await axios.get("SiteSetting");
      const data = await getSiteSettings.data.data;
      setFormContactValue(prev => {
        return {
          ...prev,
          addressCompany: data?.address,
          phone: data?.landlinePhone,
          mobile: data?.phoeNumber,
          telegramUrl: data?.telegram,
          whatsappUrl: data?.whatsApp,
          instagramUrl: data?.instagram,
          email: data?.email,
          footerText: data?.footerText,
          seoTitle: data?.mainPageSeoData.metaTitle,
          seoDescription: data?.mainPageSeoData.metaDescription,
          seoKeywords: data?.mainPageSeoData.metaKeyWords,
          seoIndexPage: data?.mainPageSeoData.indexPage,
          seoCanonical: data?.mainPageSeoData.canonical,
          seoSchema: data?.mainPageSeoData.schema,
        };
      });
      setIsLoading(false);
    };

    dataHandler();
  }, []);

  useEffect(() => {
    setErrors(settingContactInfoFormValidate(formContactValue));
  }, [formContactValue]);

  const submitHandler = event => {
    event.preventDefault();
    const inputData = formContactValue.seoCanonical;
    const linkRegex = /^(http|https):\/\/[^ "]+$/;
    if (inputData && !linkRegex.test(inputData)) {
      notify("باید لینک باشد seoCanonical", "error");
    } else {
      if (!Object.keys(errors).length) {
        notify("درحال اعمال تغییرات", "success");
      } else {
        notify("لطفا تمام فیلد هارا پر کنید!", "error");
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <form onSubmit={submitHandler} dir="rtl" className={`text-right mx-4 px-2 mt-4 mb-3`}>
          <ToastContainer
            position="top-right"
            autoClose={8000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
          />

          <div className={`d-flex justify-content-between align-items-start flex-wrap mt-2 py-2`}>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="addressCompany">
                {" "}
                آدرس شرکت{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="text"
                id="addressCompany"
                name="addressCompany"
                value={formContactValue.addressCompany}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="phone">
                {" "}
                شماره ثابت{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="tel"
                id="phone"
                name="phone"
                value={formContactValue.phone}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="mobile">
                {" "}
                شماره همراه{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="tel"
                id="mobile"
                name="mobile"
                value={formContactValue.mobile}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="instagramUrl">
                {" "}
                لینک اینستاگرام{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="url"
                id="instagramUrl"
                name="instagramUrl"
                value={formContactValue.instagramUrl}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="telegramUrl">
                {" "}
                لینک تلگرام{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="url"
                id="telegramUrl"
                name="telegramUrl"
                value={formContactValue.telegramUrl}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="whatsappUrl">
                {" "}
                لینک واتساپ{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="url"
                id="whatsappUrl"
                name="whatsappUrl"
                value={formContactValue.whatsappUrl}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="email">
                {" "}
                ایمیل{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="email"
                id="email"
                name="email"
                value={formContactValue.email}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="footerText">
                {" "}
                توضیحات فوتر (کوتاه){" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="text"
                id="footerText"
                name="footerText"
                value={formContactValue.footerText}
                onChange={formContactChangeHandler}
              />
            </Form.Group>
          </div>

          <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 px-2" dir="rtl">
            <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
              <div className={styles.text1}>اطلاعات مربوط به سئو</div>
            </div>
          </div>

          <form className="container py-3 w-100 d-flex flex-column align-items-start justify-content-center mb-4" dir="rtl">
            <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
              <h4 className={`mb-3 ${seoStyles.title_text_gray}`}>seoTitle</h4>
              <input className={`w-100 ${seoStyles.input}`} type="text" name="seoTitle" value={formContactValue.seoTitle} onChange={changeHandler} />
            </div>
            <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
              <h4 className={`mb-3 ${seoStyles.title_text_gray}`}>seoDescription</h4>
              <input
                className={`w-100 ${seoStyles.input}`}
                type="text"
                name="seoDescription"
                value={formContactValue.seoDescription}
                onChange={changeHandler}
              />
            </div>
            <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
              <h4 className={`mb-3 ${seoStyles.title_text_gray}`}>seoKeywords</h4>
              <input className={`w-100 ${seoStyles.input}`} type="text" name="seoKeywords" value={formContactValue.seoKeywords} onChange={changeHandler} />
            </div>
            <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
              <h4 className={`mb-2 ${seoStyles.title_text_gray}`}>seoIndexPage</h4>
              <Checkbox
                checked={formContactValue.seoIndexPage}
                id="checkbox"
                onClick={changeHandler}
                inputProps={{ "aria-label": "controlled" }}
                size="medium"
              />
            </div>
            <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
              <h4 className={`mb-3 ${seoStyles.title_text_gray}`}>seoCanonical</h4>
              <input
                id="seoLink"
                className={`w-100 ${seoStyles.input}`}
                type="link"
                name="seoCanonical"
                value={formContactValue.seoCanonical}
                onChange={changeHandler}
              />
            </div>
            <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
              <h4 className={`mb-3 ${seoStyles.title_text_gray}`}>seoSchema</h4>
              <input className={`w-100 ${seoStyles.input}`} type="text" name="seoSchema" value={formContactValue.seoSchema} onChange={changeHandler} />
            </div>
          </form>

          <div className="py-2 mb-4">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                  {btnLoader ? (
                    <div className={Dstyles.btn_loader_container}>
                      <div className={Dstyles.btn_spinner}></div>
                    </div>
                  ) : (
                    <button type="sumbit" onClick={submitHandler} className={`${Dstyles.filled_blue} text-white border-0`}>
                      {" "}
                      ثبت{" "}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );

  // Change Value Forms Contact
  function formContactChangeHandler(e) {
    setFormContactValue({
      ...formContactValue,
      [e.target.name]: e.target.value,
    });
  }

  function changeHandler(event) {
    if (event.target.id === "checkbox") {
      setFormContactValue(prev => {
        return { ...prev, seoIndexPage: event.target.checked };
      });
    } else {
      setFormContactValue(prev => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      formSendHandler();
    } else if (type === "succeed") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setBtnLoader(false);
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function formSendHandler() {
    setBtnLoader(true);
    try {
      var data = new FormData();
      data.append("Id", 1);
      data.append("PhoeNumber", formContactValue.mobile);
      data.append("LandlinePhone", formContactValue.phone);
      data.append("Email", formContactValue.email);
      data.append("Address", formContactValue.addressCompany);
      data.append("Instagram", formContactValue.instagramUrl);
      data.append("FooterText", formContactValue.footerText);
      data.append("Aparat", "");
      data.append("Linkdin", "");
      data.append("Telegram", formContactValue.telegramUrl);
      data.append("WhatsApp", formContactValue.whatsappUrl);
      data.append("SeoDataViewModel.MetaTitle", formContactValue.seoTitle);
      data.append("SeoDataViewModel.MetaDescription", formContactValue.seoDescription);
      data.append("SeoDataViewModel.MetaKeyWords", formContactValue.seoKeywords);
      data.append("SeoDataViewModel.IndexPage", formContactValue.seoIndexPage || false);
      data.append("SeoDataViewModel.Canonical", formContactValue.seoCanonical);
      data.append("SeoDataViewModel.Schema", formContactValue.seoSchema);
      data.append("Twitter", "https://www.instagram.com/azarmelk_ir");
      const aboutusTexts = await axios.post("SiteSetting", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      notify("عملیات با موفقیت انجام شد", "succeed");
    } catch (error) {
      notify("خطای سرور", "error");
      // console.log(error)
    }
    setBtnLoader(false);
  }
};

export default SettingContactInfoForm;
